export class Versions {
    constructor() {}

    public assortmentExcel: string = '1.2.2';
    public changeBufferExcel: string = '1.2.2';
    public bufferTableExcel: string = '1.0.0';
    public orders: string = '1.0.2';
}



// WEBPACK FOOTER //
// ./src/app/shared/models/vesions.ts